import FileSaver from 'file-saver';

import { post } from './request';
import { getAccountId } from './firebase';

const generateLabels = (job, tasks, labelFormat, options, responseFormat) => {
  const accountId = getAccountId();
  return post({
    url: `/v1/accounts/${accountId}/jobs/${job.id}/labels`,
    headers: {
      'Content-Type': 'application/json',
      Accept: responseFormat,
    },
    data: {
      tasks,
      labelFormat,
      options,
    },
    responseType: 'blob',
  });
};

export const generateZebraLabels = (job, tasks, labelFormat, options) => {
  return generateLabels(job, tasks, labelFormat, options, 'application/json')
    .then((resp) => resp.data);
}

export const generatePdfLabels = (job, tasks, labelFormat, options) => {
  return generateLabels(job, tasks, labelFormat, options, 'application/pdf')
    .then((resp) => {
      FileSaver.saveAs(resp, `labels-${new Date().toISOString()}.pdf`);
      return resp;
    });
}

// export const generatePdfLabels = (job, tasks, labelFormat, sheets, embedType, blank) => {
//   const accountId = getAccountId();
//   return post({
//     url: `/v1/accounts/${accountId}/jobs/${job.id}/labels`,
//     headers: {
//       'Content-Type': 'application/json',
//       Accept: 'application/pdf',
//     },
//     responseType: 'blob',
//     data: {
//       tasks,
//       labelFormat,
//       labels: {
//         sheets,
//         embedType,
//         blank,
//       },
//     },
//   })
//     .then((resp) => resp.blob())
//     .then((resp) => {
//       console.log('r3', resp);
//       // const data = new Blob(resp.blob(), { type: 'application/pdf' });
//       FileSaver.saveAs(resp, 'labels.pdf');
//       return resp;
//     });
// };



// WEBPACK FOOTER //
// ./src/utils/labels.js